import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";

const FreePlayLunch2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <FreePlayLunchDiv>
      <EventFinished scheduleKeyName="freePlayLunch2025" eventType="promotion" />
      <Hero
        bgImage="promotions/dining/free-play-lunch-2025/Free_Play_Lunch_Header-2560x800px_LP.jpg"
        buttonSettings={null}
        image={`promotions/dining/free-play-lunch-2025/Free_Play_Lunch_Logo_${i18n.language}.png`}
        description={t("diningPromos.freePlayLunch2025.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.freePlayLunch2025.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.freePlayLunch2025.content.lunch.description")}
              </ReactMarkdown>
            </Col>
            <Col className="pt-md-4 position-relative">
              <ResponsiveImage
                src={`promotions/dining/free-play-lunch-2025/Free_Play_Lunch_Secondary-LP-image-2400x1600_${i18n.language}.jpg`}
                alt={t("diningPromos.freePlayLunch2025.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.freePlayLunch2025.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </FreePlayLunchDiv>
  );
};

const FreePlayLunchDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
`;

const MainContentDiv = styled.div``;

export default FreePlayLunch2025;
